export default "__VITE_ASSET__38903210__"